var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "precautions" }, [
    _c("img", {
      attrs: { src: require("@/assets/images/page/notice.png"), alt: "" },
    }),
    _c("div", [
      _vm.title ? _c("h2", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
      _vm.matter.length > 0
        ? _c(
            "div",
            { staticClass: "matter" },
            _vm._l(_vm.matter, function (item, index) {
              return _c(
                "p",
                {
                  key: index,
                  style: {
                    color: item.color,
                    "font-weight": item.weight ? "bolder" : "none",
                  },
                },
                [_vm._v(" " + _vm._s(item.txt))]
              )
            }),
            0
          )
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }